"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowUp = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ArrowUp = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M10.56 5.445A1.493 1.493 0 0111.62 5h.76c.397.005.777.164 1.06.445l10.264 10.387a1.015 1.015 0 010 1.434l-1.42 1.435a.976.976 0 01-1.4 0L12 9.71 3.117 18.7a.995.995 0 01-1.42 0L.295 17.266a1.015 1.015 0 010-1.434L10.56 5.445z" })); };
exports.ArrowUp = ArrowUp;
//# sourceMappingURL=arrow-up.js.map